import { queryKeys } from '../../queryKeys';
import { useQuery } from '../base';

export function usePendingQuestionnaireSubmissions({
  enabled = true,
}: { enabled?: boolean } = {}) {
  const { queryFn, queryKey } =
    queryKeys.questionnaireSubmissions.fetchPending();
  return useQuery({ enabled, queryFn, queryKey });
}
